// Global cause cookie initialization (runs on every page)
document.addEventListener('DOMContentLoaded', function () {
    // Common function to set all cause cookies
    function setCauseCookies(name, shortCode, defaultShortCode) {
      setCookie('user_cause_name', name, 30);
      setCookie('user_cause', shortCode, 30);
      setCookie('default_cause', defaultShortCode, 30);
    }
  // Use global variables from cause-init.liquid
  var defaultShortCode = window.DEFAULT_CAUSE_HANDLE;
  var defaultCause = window.DEFAULT_CAUSE_NAME;
  var causeMap = window.CAUSE_MAP || {};

  // Helper functions
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c && c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c && c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Only set cookies if not already set or if default changed
  var cookieShortCode = getCookie('user_cause');
  var cookieName = getCookie('user_cause_name');
  var defaultCauseCookie = getCookie('default_cause');

  // If logged in and customer has a cause, do nothing (block JS will handle UI)
  if (window.IS_LOGGED_IN && window.CUSTOMER_CAUSE_HANDLE) {
    return;
  }

  // Guest logic: set cookies if missing or default changed
  var storedShortCode = null;
  if (!cookieShortCode || !cookieName) {
    try {
      storedShortCode = localStorage.getItem('user_cause');
    } catch (e) {}
    //Set data from local storage if cookie missing or existing users
    if (storedShortCode) {
      // Map short code to name using causeMap
      var mappedName = causeMap[storedShortCode] ? causeMap[storedShortCode] : defaultCause;
      mappedName = mappedName.replace(/&#39;/g, "'");
      setCauseCookies(mappedName, storedShortCode, defaultShortCode);
    } else {
      setCauseCookies(defaultCause, defaultShortCode, defaultShortCode);
    }
  } else if (defaultCauseCookie && defaultCauseCookie !== defaultShortCode) {
    // If user selection matches old default, update to new default
    if (cookieShortCode === defaultCauseCookie) {
      setCauseCookies(defaultCause, defaultShortCode, defaultShortCode);
    } else {
      // Always update default_cause cookie to new default
      setCookie('default_cause', defaultShortCode, 30);
    }
  }
});

/* Cause Architecture — Horizon Theme Integration (PDP + Cart + Deep-link) */

(() => {
    const COOKIE = 'user_cause';
    const MAX_AGE = 60 * 60 * 24 * 30; // 30 days

    const params = new URLSearchParams(window.location.search);
    const urlCause = params.get('cause'); // short_code or handle

    if (urlCause) {
        setCookie('user_cause_name', window.CAUSE_MAP[urlCause], 30);
        setCookie('user_cause', urlCause, 30);   
    }
  
    // ---- Utilities
    const getCookie = (name) =>
      document.cookie.split('; ').find(r => r.startsWith(name + '='))?.split('=')[1] || '';
  
    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      }
  
    const postJSON = async (url, body) => {
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {})
      });
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
    };
  
    const getJSON = async (url) => {
      const r = await fetch(url, { method: 'GET' });
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
    };
  
    const cartUpdateAttributes = async (attrs) => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      } catch (e) { console.warn('cart attrs update failed', e); }
    };
  
    // ---- Apply resolved cause everywhere
    async function applyCause(charity_handle) {
    
    //   if (!resolved?.charity_handle) return;
  
    //   // 1) Cookie
    //   setCookie(COOKIE, resolved.charity_handle);
      // 2) Cart attributes (string values)
      await updateAllLineItemProperties({
        _benefit_unit: window.CAUSE_MAP_OBJ[charity_handle]?.benefit_unit || '1',
        _cause: window.CAUSE_MAP_OBJ[charity_handle]?.short_code || '1',
      });
  
      // 3) Persist customer metafield when logged in (no-op if not logged)
      try {
        // Check if the user is logged in and get the customer ID
        const loggedInCustomerId = window.CUSTOMER_ID || null; // Ensure this variable is available globally
    
        if (!loggedInCustomerId) {
          console.warn('Customer ID is not available. Cannot apply cause.');
          return;
        }
    
        // Construct the URL
        const url = `/apps/cause/select`;
    
        // Make the POST request with the charity_handle and customer_id in the body
        await postJSON(url, {
          charity_handle: charity_handle,
          logged_in_customer_id: loggedInCustomerId, // Pass the customer ID in the body
        });
    
        console.log('Cause applied successfully with customer ID:', loggedInCustomerId);
      } catch (error) {
        console.warn('Failed to apply cause:', error);
      }
    }
  
    // ---- Resolve precedence on every page
    (async function resolveAndInit() {
    //   try {
    //     const params = new URLSearchParams(window.location.search);
    //     const urlCause = params.get('cause'); // short_code or handle
    //     const customerCause = window.CUSTOMER_CAUSE_HANDLE || null;
    //     const cookieCause = decodeURIComponent(getCookie(COOKIE) || '');
    //     const defaultHandle = window.DEFAULT_CAUSE_HANDLE || null;
  
    //     // 1) URL param takes precedence
    //     if (urlCause) {
    //       const res = await postJSON('/apps/cause/resolve', { short_code: urlCause });
    //       if (res?.active) {
    //         await applyCause(res);
    //         return;
    //       }
    //     }
  
    //     // 2) Logged-in customer selection (over cookie/default)
    //     if (window.IS_LOGGED_IN && customerCause && customerCause !== cookieCause) {
    //       const res = await postJSON('/apps/cause/resolve', { handle: customerCause });
    //       if (res?.active) {
    //         await applyCause(res);
    //         return;
    //       }
    //     }
  
    //     // 3) Existing cookie → refresh Max-Age
    //     if (cookieCause) {
    //       setCookie(COOKIE, cookieCause);
    //       return;
    //     }
  
    //     // 4) No cookie → set the site default into cookie
    //     if (defaultHandle) {
    //       const res = await postJSON('/apps/cause/resolve', { handle: defaultHandle });
    //       if (res?.active) { await applyCause(res); return; }
    //     }
    //     // Fallback: call default endpoint if metafield isn’t set
    //     const def = await getJSON('/apps/cause/default');
    //     if (def?.active) await applyCause(def);
    //   } catch (e) {
    //     console.warn('cause init failed', e);
    //   }
    })();
  
    // ============================= PDP PREVIEW =============================
    // Displays: “This item funds <units> <benefitText>” in an element:
    // <div data-cause-preview></div>
    // Hook: variant change (Horizon/Dawn: listen to both change + custom events)
  
    function getCookieHandle() {
      return decodeURIComponent(getCookie(COOKIE) || '');
    }
  
    async function computePdpPreview(variantId, unitPrice) {
    
      const handle = getCookieHandle();
      let netlify_domain = window.netlify_function_domain;  
      if (!handle || !variantId || !Number.isFinite(unitPrice)) return;
      try {
        const res = await postJSON(`${netlify_domain}/.netlify/functions/cause-compute-variant`, {
          variantId,
          unitPrice,
          charityHandle: handle
        });
  
        // Select all divs with the class 'charity-message-block'
        const charityMessageBlocks = document.querySelectorAll('div.charity-message-block');
  
        // Example: Iterate over each block and log it
        charityMessageBlocks.forEach(block => {
          block.innerHTML = `<p>Provides ${res.donationUnits} ${res.benefitText || 'benefits'} to ${res.charityName || 'handle'}</p>`;
        });
    
        //create hidden input to the form to pass data to checkout
        const params = {
          handle: handle,
          benefitUnit: res.benefitUnit,
          sharePercentage: res.sharePercentage || '20',
          costToShip: res.costToShip || '59',
          oc: res.oc || '',
        };

        window.addHiddenInputsToCartForm(params)
  
      } catch (e) {
        console.warn('compute-variant failed', e);
      }
    }
  
    // Variant change glue for Horizon/Dawn-like themes
    function getCurrentVariantFromForm(form) {
      // Prefer hidden input name="id"
      const idInput = form?.querySelector('input[name="id"]');
      const variantNumericId = idInput?.value;
      if (!variantNumericId) return null;
      return `gid://shopify/ProductVariant/${variantNumericId}`;
    }
  
    function getUnitPriceFromPage() {
      // Prefer an element with a data-amount attribute you can add in Liquid.
      // If your theme uses money-format HTML, adapt this function to parse.
      const el = document.querySelector('[data-product-price][data-amount]');
      const priceElement = document.querySelector(".price[data-price]");
      if (priceElement) return Number(priceElement.getAttribute("data-price"));
      // Fallback: try meta price if you expose it yourself
      return NaN;
    }
  
    function bindPdp() {
        
      const productForm = document.querySelector('form[action*="/cart/add"]');
      //check for input with with id as is_pdp and value as true
      const isPdpInput = document.querySelector('input#is_pdp[name="is_pdp"][value="true"]');
      if(!isPdpInput) return;
    
      const trigger = async () => {
        const gid = getCurrentVariantFromForm(productForm);
        const price = getUnitPriceFromPage();
        await computePdpPreview(gid, price);
      };
  
      // Initial render
      trigger();
  
      // Change on variant select input
      productForm.addEventListener('change', (e) => {
        if (e.target && (e.target.name === 'id' || e.target.closest('variant-radios') || e.target.closest('variant-selects'))) {
          trigger();
        }
      });
  
      // Some themes dispatch custom events
      document.addEventListener('variant:change', trigger);
      document.addEventListener('product:variant-change', trigger);
    }
  
    // ============================= CART PREVIEW =============================
    // Displays: <div data-cause-cart-preview></div> near checkout button
    async function computeCartPreview() {
    
      const handle = getCookieHandle();
      if (!handle) return;
  
      try {
        const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' }})).json();
        
        //skip gift card items from the cart items
        cart.items = cart.items.filter(item => !item.gift_card);
        const lines = (cart.items || []).map(it => ({
          variantId: `gid://shopify/ProductVariant/${it.variant_id}`,
          quantity: it.quantity,
          // Shopify cart.js price is in cents; convert to your unit (pre-tax if you need)
          perUnitPrice: it.price / 100
        }));
        if (!lines.length)
        {  
          const charityMessageCartBlock = document.getElementById('charity-message-cart-block');
          if(charityMessageCartBlock) {
            charityMessageCartBlock.classList.add('d-none');
            charityMessageCartBlock.innerHTML = '';
            charityMessageCartBlock.classList.remove('loading');
          }
          return;
        }
  
        let netlify_domain = window.netlify_function_domain;  
        // const res = await postJSON(`${netlify_domain}/.netlify/functions/cause-compute-cart`, { lines, charityHandle: handle });

        const res = await postJSON(`${netlify_domain}/.netlify/functions/cause-compute-cart`, {
          lines,
          charityHandle: handle
        });

  
        // const el = document.querySelector('[data-cause-cart-preview]');
        // if (el && typeof res?.totalUnits !== 'undefined') {
        //   el.textContent = `This order funds ${res.totalUnits} ${res.benefitText || 'benefits'}.`;
        // }

        //get element by id charity-message-cart-block and update its inner html
        const charityMessageCartBlock = document.getElementById('charity-message-cart-block');
        if (charityMessageCartBlock && typeof res?.totalUnits !== 'undefined') {
          charityMessageCartBlock.innerHTML = `<span>Provides ${res.totalUnits} ${res.benefitText || 'benefits'} to ${res.charityName || 'handle'}. Change <a>cause partner?</a></span>`;
          //remove d-none class from the element
          charityMessageCartBlock.classList.remove('loading');
        } else if(charityMessageCartBlock) {
          charityMessageCartBlock.classList.add('d-none');
          charityMessageCartBlock.innerHTML = '';
          charityMessageCartBlock.classList.remove('loading');
        }
  
        // // Persist attributes so checkout & notifications can read them
        // await cartUpdateAttributes({
        //   charity_handle: handle,
        //   charity_name: document.querySelector('[data-cause-name]')?.textContent || '',
        //   donation_units_preview: String(res.totalUnits ?? 0),
        //   benefit_text: res.benefitText || 'benefits'
        // });
      } catch (e) {
        console.warn('compute-cart failed', e);
      }
    }
  
    function bindCart() {
        //check for input with with id as is_cart and value as true
      const isCartInput = document.querySelector('input#is_cart[name="is_cart"][value="true"]');
      if(!isCartInput) return;

      // Run on cart page load
      computeCartPreview();
  
      // Recompute on quantity changes (common input name in many themes)
      document.addEventListener('change', (e) => {
        if (e.target && (e.target.name === 'updates[]' || e.target.closest('[data-quantity-input]'))) {
          // Give the theme time to update cart first
          setTimeout(computeCartPreview, 250);
        }
      });
  
      // If theme emits a custom event after cart refresh
      document.addEventListener('cart:refresh', () => setTimeout(computeCartPreview, 50));
  
      // Mutation observer fallback (if cart DOM is updated by XHR)
      const cartRoot = document.querySelector('cart-items, [data-cart-items], form[action*="/cart"]');
      if (cartRoot) {
        new MutationObserver(() => { setTimeout(computeCartPreview, 50); })
          .observe(cartRoot, { childList: true, subtree: true });
      }
    }

    /**
     * Bulk-updates properties on all line items.
     * @param {Object} newProps - Properties to set (e.g., { "Gift wrap": "Yes" }).
     * @param {Object} options  - { merge: true } to merge with existing properties.
     */
    async function updateAllLineItemProperties(newProps, { merge = true } = {}) {
        const cart = await getCart();
        const lines = cart.items || [];
    
        // Process sequentially to minimize race conditions and avoid duplicate merges
        for (const line of lines) {
            const existing = line.properties || {};
            const properties = merge ? { ...existing, ...newProps } : { ...newProps };
        
            // To REMOVE a property, set it to null or empty string '' (see notes below)
            // e.g. properties["Gift wrap"] = '';
        
            await updateLinePropertiesByKey(line.key, line.quantity, properties);
        }
    
        // Return fresh cart
        return getCart();
    }

    async function getCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Failed to fetch cart');
        return res.json();
    }

    async function updateLinePropertiesByKey(itemKey, quantity, properties) {
        console.log('debug==== Updating line item', itemKey, 'with properties', properties);
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
            id: itemKey,          // or use "line": 2 to target by index
            quantity: quantity,    // Include quantity in the request body
            properties           // { Engraving: "New text", "Gift wrap": "No" }
            })
        });
        if (!res.ok) throw new Error('Failed to change line item');
        return res.json();
    }
      
  
    // ---- Boot
    bindPdp();
    bindCart();
    document.addEventListener('DOMContentLoaded', () => {

      //apply cause if logged in and if cause param is set in the URL
      const params = new URLSearchParams(window.location.search);
      const urlCause = params.get('cause'); // short_code or handle

      const handle = getCookieHandle();

      // If user is logged in and has a cause handle, but it's not present in CAUSE_MAP_OBJ, set to default
      if(urlCause){
        window.IS_LOGGED_IN && applyCause(urlCause);

        // reload the page without the cause param in the URL
        const url = new URL(window.location.href);
        url.searchParams.delete('cause');
        window.history.replaceState({}, document.title, url.toString());
        window.location.reload();

      }else if(window.IS_LOGGED_IN && window.CUSTOMER_CAUSE_HANDLE) {
        if (!window.CAUSE_MAP_OBJ[window.CUSTOMER_CAUSE_HANDLE]) {
          // User's cause is not present (inactive/draft), set to default
          applyCause(window.DEFAULT_CAUSE_HANDLE);
        }else if(window.CUSTOMER_CAUSE_HANDLE != handle){
            applyCause(handle);
        }
      }else if (window.IS_LOGGED_IN && window.CUSTOMER_CAUSE_HANDLE == null && window.DEFAULT_CAUSE_HANDLE){ 
        applyCause(handle);
      }
    });

    // Listening for the custom event
    document.addEventListener('causeChanged', function (event) {
        
        bindPdp();

        //if browser url has cart string then call bindCart();
        if (window.location.href.includes('cart')) {
            bindCart();
        }        
    
        //update user's cause selection in the metafields
        if(window.IS_LOGGED_IN){
            applyCause(event.detail.shortCode);
        }
        // Perform actions based on the event
        // Example: Update the DOM or trigger another function
    });

    //call the bindCart function when cart is updated in shopify theme
    document.addEventListener('DOMContentLoaded', () => {
      // Listen for clicks inside elements with the "quantity-selector" class
      document.querySelectorAll('.quantity-selector').forEach((quantitySelector) => {
        quantitySelector.addEventListener('click', (event) => {
          // Check if the clicked element is a button
          if (event.target.tagName === 'BUTTON') {
            //wait for 500ms and then call the bindCart function
            setTimeout(() => {
              bindCart();
            }, 1000);
            // bindCart();
          }
        });
      });
    });
  })();
